import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon, ChartBarIcon } from "@heroicons/react/outline";
import BranchHierarchy from "../../components/Branch/views/BranchHierarchy";
import BranchComparison from "../../components/Branch/views/BranchComparison";

const BranchHierarchyPage = () => {
  const navigate = useNavigate();
  const [view, setView] = React.useState("hierarchy"); // hierarchy or comparison

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate("/branches")}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            >
              <ArrowLeftIcon className="h-4 w-4" />
              Back
            </button>

            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Branch Organization
              </h1>
              <p className="text-gray-600 mt-1">
                View branch hierarchy and compare branches
              </p>
            </div>
          </div>

          <div className="flex gap-2">
            <button
              onClick={() => setView("hierarchy")}
              className={`px-4 py-2 rounded-lg transition-colors ${
                view === "hierarchy"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              Hierarchy View
            </button>
            <button
              onClick={() => setView("comparison")}
              className={`px-4 py-2 rounded-lg transition-colors \${
                view === 'comparison' 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Compare Branches
            </button>
          </div>
        </div>
      </div>

      {view === "hierarchy" ? <BranchHierarchy /> : <BranchComparison />}
    </div>
  );
};

export default BranchHierarchyPage;
